import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { OfficeSelectorInput } from "./OfficeSelectorInput";
import { HookFormOfficeSelectorInputProps } from "./OfficeSelectorInput.types";

export const HookFormOfficeSelectorInput = <T extends FieldValues>({
  form,
  name,
  rules,
  onChange,
  multiselect = false,
  ...props
}: HookFormOfficeSelectorInputProps<T>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => {
        if (multiselect) {
          // For multiselect, field.value should be an array of strings
          const values = Array.isArray(field.value) ? field.value : [];
          return (
            <OfficeSelectorInput
              {...props}
              multiselect={true}
              offices={values}
              onChange={(ids) => {
                field.onChange(ids);
                onChange?.(ids);
              }}
              error={fieldState.error?.message}
            />
          );
        } else {
          // For single select, field.value should be a string
          const value = typeof field.value === "string" ? field.value : "";
          return (
            <OfficeSelectorInput
              {...props}
              multiselect={false}
              offices={value ? [value] : []}
              defaultValue={value}
              onChange={(ids) => {
                const newValue = ids.length > 0 ? ids[0] : "";
                field.onChange(newValue);
                onChange?.(ids);
              }}
              error={fieldState.error?.message}
            />
          );
        }
      }}
    />
  );
};
